var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('baidu-map',{staticClass:"bm-view",attrs:{"zoom":19,"center":{ lng: 118.731134, lat: 32.011681 }},on:{"ready":_vm.init}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }